import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../components/Root.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function NotFound() {
  useEffect(() => {
    document.title = 'Not Found｜WeSplit';
  }, []);
  return (
    <div className="not-found-404">
      <Navbar />
      <div className="not-found-404__content">
        <div className="not-found-404__image-text">
          <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2F404-img.png?alt=media&token=c32e7113-79a5-48d1-9c3f-1ca922571ab7" alt="404" className="not-found-404__img" />
        </div>
        <div className="lp-section-header">
          <h2 className="lp-section-title">
            We've Lost This <span className="lp-section-title-highlight">Page</span>
          </h2>
          <p className="lp-section-subtitle">
            Sorry, this page you are looking for doesn't exist or has been removed
          </p>
        </div>
        <Link to="/" className="primary">Back to homepage</Link>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound; 